import SectionVideo2 from "../../../sections/home/index2/section-video2";
import SectionWhyChooseUs4 from "../../../sections/company/about/section-why-choose-us4";
import SectionClients2 from "../../../sections/home/index2/section-clients2";
import SectionCounter1 from "../../../sections/home/index/section-counter1";
import ItodoImage from "../../../elements/itodo-img";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { loadScript } from "../../../../globals/constants";
import { serviceDetailContent, services, neuronMedia } from "../../../../globals/neuron-content";

function ServicesDetailPage() {
  const { slug } = useParams();
  const service = services.find((item) => item.slug === slug);
  const detailContent = service ? { ...serviceDetailContent, service } : serviceDetailContent;

  useEffect(() => {
    loadScript("js/custom.js");
  }, []);

  return (
    <>
      <div className="section-full p-b80 sx-ser-detail-outer sx-bg-white">
        <div className="sx-ser-detail-l-pic p-b80">
          <div className="sx-media relative">
            <ItodoImage src={service?.image || neuronMedia.banners.operations} alt={service ? service.title : "Neuron services"} />
            <div className="sx-bnr-outline-text">
              <h1>{detailContent.watermark}</h1>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="section-content">
            <div className="sx-our-service-detail">
              <div className="section-head2">
                <div className="sx-head-s-title">Service Delivery Model</div>
                <div className="sx-head-l-title">
                  <h2 className="sx-title2">{service ? service.title : detailContent.title}</h2>
                </div>
              </div>
              <div className="sx-our-service-info m-b80">
                {service ? (
                  <>
                    <p className="sx-service-tag">{service.category}</p>
                    <p className="sx-service-summary">{service.summary}</p>
                    <p>{service.detail}</p>
                  </>
                ) : (
                  detailContent.intro.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))
                )}
                <div className="row sx-about-icon-bx1-column p-t50 p-b20">
                  {detailContent.pillars.map((pillar) => (
                    <div key={pillar.title} className="col-lg-4 col-md-6 m-b30">
                      <div className="sx-icon-bx-2">
                        <div className="sx-media">
                          <i className={pillar.icon} />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title">{pillar.title}</span>
                          <span className="sx-icon-bx-title-info">{pillar.subtitle}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {!service && <p>{detailContent.closing}</p>}
              </div>

              <SectionCounter1 />
            </div>
          </div>
        </div>
      </div>

      <SectionVideo2 />
      <SectionWhyChooseUs4 />
      <SectionClients2 />
    </>
  );
}

export default ServicesDetailPage;
